import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledMain = styled.main`
  background: #F2F2F2;
  display: block;
  margin: 0 auto;
  text-align: left;
  position: relative;
  height: auto;
  width: 100%;
  z-index: 0;
`;

Main.propTypes = {
  children: PropTypes.any,
};

export default function Main (props) {
  const {children} = props;
  return (
    <StyledMain>
      {children}
    </StyledMain>
  )
}
